import React from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
type QuantityStepperProps = {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  size?: 'sm' | 'lg';
};
export function QuantityStepper({
  value,
  onChange,
  min = 1,
  size = 'sm'
}: QuantityStepperProps) {
  const h = size === 'lg' ? 'h-14' : 'h-9';
  const w = size === 'lg' ? 'w-12' : 'w-9';
  return <div className={`inline-flex ${h} items-center rounded-full border border-line bg-white`} data-id="element-360" data-mp="1vt1qe8hnkef">
      <button type="button" onClick={() => onChange(Math.max(min, value - 1))} className={`grid ${h} ${w} place-items-center rounded-full text-ink transition-colors duration-150 hover:bg-surface disabled:opacity-40`} aria-label="Minder" disabled={value <= min && min > 0} data-id="element-361" data-mp="31bg6bbmrs3yf">
        <MinusIcon className="h-3.5 w-3.5" data-id="element-362" data-mp="pjswrqcu1wyt" />
      </button>
      <span className="w-6 text-center text-sm font-medium tabular-nums" aria-live="polite" data-id="element-363" data-mp="pjark48708er">
        {value}
      </span>
      <button type="button" onClick={() => onChange(Math.min(20, value + 1))} className={`grid ${h} ${w} place-items-center rounded-full text-ink transition-colors duration-150 hover:bg-surface`} aria-label="Meer" data-id="element-364" data-mp="2x9daru0jlyjm">
        <PlusIcon className="h-3.5 w-3.5" data-id="element-365" data-mp="2n9w53clajknn" />
      </button>
    </div>;
}